module.exports = __webpack_public_path__ + "img/brain-540w.880b7598.jpg";